import { ReactComponent as Close } from './Close.svg';
import { ReactComponent as Dashboard } from './Dashboard.svg';
import { ReactComponent as Exercises } from './Exercises.svg';
import { ReactComponent as Divider } from './Divider.svg';
import { ReactComponent as FullPattern } from './FullPattern.svg';
import { ReactComponent as FullPatternMobile } from './FullPatternMobile.svg';
import { ReactComponent as HungryPattern } from './HungryPattern.svg';
import { ReactComponent as HungryPatternMobile } from './HungryPatternMobile.svg';
import { ReactComponent as Logo } from './Logo.svg';
import { ReactComponent as Menu } from './Menu.svg';
import { ReactComponent as Profile } from './Profile.svg';
import { ReactComponent as Logout } from './Logout.svg';
import { ReactComponent as Bookings } from './Bookings.svg';
import { ReactComponent as Back } from './back.svg';

const SVG = {
  Close,
  Dashboard,
  Exercises,
  FullPattern,
  FullPatternMobile,
  HungryPattern,
  HungryPatternMobile,
  Logo,
  Menu,
  Profile,
  Logout,
  Divider,
  Bookings,
  Back,
};

export default SVG;
